import { braceletMaterialFields, caseMaterialFields, functionsFields, glassFields, movementFields, stateFields } from "../../../utils/fields";
import AdminDetails from "./adminDetails";
import AdminCallout from "./adminCallout";

export function formatAdminPrice(price: any) {
    if (price === undefined || price === null || price === "") {
        return "";
    }
    const value = Number(price);
    if (isNaN(value)) {
        return String(price);
    }
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
}

// ficha técnica completa de um relógio (antes era um sub-modal preto repetido em 3 telas)
export default function AdminWatchSpecs({ watch }: { watch: { [key: string]: any } }) {
    return (
        <div className="flex flex-col gap-5">
            <AdminDetails
                items={[
                    { label: "Serial", value: watch?.serial },
                    { label: "Estado", value: stateFields[watch?.state] },
                    { label: "Funções", value: Array.isArray(watch?.functions) ? watch.functions.map((f: string) => functionsFields[f]).filter(Boolean).join(", ") : "" },
                    { label: "Movimento", value: movementFields[watch?.movement] },
                    { label: "Modelo do movimento", value: watch?.movementModel },
                    { label: "Material do bracelete", value: braceletMaterialFields[watch?.braceletMaterial] },
                    { label: "Material da caixa", value: caseMaterialFields[watch?.caseMaterial] },
                    { label: "Diâmetro (mm)", value: watch?.diameter },
                    { label: "Estanqueidade (ATM)", value: watch?.tightness },
                    { label: "Vidro", value: glassFields[watch?.glass] },
                    { label: "Caixa e documentos originais", value: watch?.boxAndDocuments ? "Sim" : "Não" },
                    { label: "Preço", value: formatAdminPrice(watch?.price) },
                    { label: "Conteúdo adicional", value: watch?.content, full: true },
                    { label: "Descrição", value: watch?.description, full: true },
                ]}
            />
            {
                watch?.original ?
                    <AdminCallout tone="success">Declarada responsabilidade sobre a autenticidade do produto.</AdminCallout>
                    : <AdminCallout tone="danger">Não declarada responsabilidade sobre a autenticidade do produto.</AdminCallout>
            }
        </div>
    )
}
